import radium from 'radium';
import Title from './Title.jsx';
import Subtitle from './Subtitle.jsx';
import DateLocation from './DateLocation.jsx';
import Description from './Description.jsx';
import Image from './Image.jsx';
import Section from '../../components/section/Section.jsx';

function EventInfos(props) {
	const style = {
		container: {
			display: 'inline-block',
			width: '100%',
		},
		outerContainer: {
			margin: '0.5em 0 0',
			'@media (min-width : 768px)': {
				margin: '0.5em 0 0',
			},
		},
	};

	return (
		<Section style={style.outerContainer}>
			<Title title={props.title} />
			<Subtitle subtitle={props.subtitle} />
			<div style={style.container}>
				<Image imageMetaData={props.imageMetaData} />
				<div>
					<DateLocation date={props.date} location={props.location} />
					{props.description &&
						<Description description={props.description} />
					}
				</div>
			</div>
		</Section>
	);
}


export default radium(EventInfos);
